<template>
  <div>
    <v-card-row actions>
      <Timer v-if="service.start_at" :value="endDate" @finish="stop"/>
      <v-spacer />
      <template v-if="timeLeft">
        <v-btn
          v-if="service.start_at"
          class="ml-3"
          @click.native.stop="stop"
          primary light
          :loading="loading">
          {{ $t('purchase.availability.stop') }}
        </v-btn>
      </template>
    </v-card-row>
    <template v-if="service.start_at && this.conversation">
      <v-divider />
      <messenger-chat
        no-header
        :conversation="conversation">
      </messenger-chat>
      <v-divider />
    </template>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import http from '@/utils/http'
  import purchase from '@/mixins/purchase'
  import { MessengerChat } from '@/components/messenger'
  import Timer from '@/components/Timer'
  export default {
    mixins: [purchase],
    components: {
      MessengerChat,
      Timer
    },
    computed: {
      ...mapGetters({
        conversations: 'skiliko/conversations/collection'
      }),
      conversation_id () {
        return this.purchase.service.metadata._id
      },
      conversation () {
        return this.conversations[this.conversation_id]
      },
      service () {
        return this.purchase.service
      },
      timeLeft () {
        const left = (this.service.duration * 60) - this.service.spent
        return left < 0 ? 0 : left
      },
      endDate () {
        return new Date(new Date(this.service.start_at).getTime() + (this.timeLeft * 1000))
      }
    },
    methods: {
      ...mapActions({
        fetch: 'skiliko/conversations/fetch',
        fetchPurchase: 'skiliko/purchases/fetch'
      }),
      async stop () {
        await http().post(`/availability_services/${this.purchase.id}/stop`)
        await this.fetchPurchase({ id: this.purchase.id })
        if (!this.conversation) this.fetch({ id: this.conversation_id })
      }
    },
    mounted () {
      if (!this.conversation_id) return
      this.fetch({ id: this.conversation_id })
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/purchase/Availability.vue